import React, { useEffect, useMemo } from 'react';
import Button from '@mui/material/Button';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@mui/material';

const DEFAULT_LANGUAGE = 'en';
const LANGUAGES = [
  { code: 'en', label: 'English - EN', shortLabel: 'EN' },
  { code: 'fr', label: 'Français - FR', shortLabel: 'FR' },
];

const LanguageDropdown = ({ wullWidth = false }) => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const currentLang = useMemo(() => {
    const lang = i18n.resolvedLanguage || i18n.language || DEFAULT_LANGUAGE;
    return LANGUAGES.some((item) => item.code === lang)
      ? lang
      : DEFAULT_LANGUAGE;
  }, [i18n.language, i18n.resolvedLanguage]);

  useEffect(() => {
    document.documentElement.setAttribute('lang', currentLang);
  }, [currentLang]);

  const onSelect = (code) => {
    if (code === currentLang) return;
    i18n.changeLanguage(code);
    setAnchorEl(null);
  };

  const selectedLanguage = LANGUAGES.find((item) => item.code === currentLang);
  const label = wullWidth
    ? selectedLanguage?.label.slice(0, -4) || DEFAULT_LANGUAGE.toUpperCase()
    : selectedLanguage?.shortLabel || DEFAULT_LANGUAGE.toUpperCase();
  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        onClick={(event) => setAnchorEl(event.currentTarget)}
        variant="text"
        color="secondary"
        size="medium"
        sx={{ justifyContent: 'flex-start' }}
        startIcon={<LanguageIcon sx={{ fontSize: 20 }} />}
        fullWidth
      >
        {label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            width: 188,
            borderRadius: '12px',
            overflow: 'hidden',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: '#eeeeee',
            boxShadow:
              '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
            boxSizing: 'border-box',
          },
        }}
        slotProps={{
          list: {
            sx: {
              p: 2,
            },
          },
        }}
      >
        {LANGUAGES.map(({ code, label: itemLabel }) => (
          <MenuItem
            key={code}
            selected={code === currentLang}
            onClick={() => onSelect(code)}
            sx={{
              borderRadius: 1,
              fontFamily: '"Red Hat Text", sans-serif',
              color: '#000000',
              '&.Mui-selected': {
                background: '#eef7f2 !important',
                fontWeight: 500,
                color: '#2A7559',
              },
              '&.Mui-selected:hover': {
                background: '#eef7f2',
              },
              '&.Mui-focusVisible': {
                background: '#eef7f2',
              },
            }}
          >
            {itemLabel}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageDropdown;
